import type { IProfitCenterRequestItem } from '../../../../../../store/slices/valueChainMap/interfaces/IProfitCenterRequestItem';

const hasProfitCenterInBusinessModel = (items: IProfitCenterRequestItem[] = []): boolean => (
  items.some((item) => item.parent.length > 0 || hasProfitCenterInBusinessModel(item.children || []))
);

export default hasProfitCenterInBusinessModel;
